import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Card, Alert, Spinner, Badge } from 'react-bootstrap'
import { chatsAPI } from '../../services/chatsApi'

const ChatsList = () => {
  const [chats, setChats] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadChats()
    window.addEventListener('chats:updated', loadChats)
    return () => window.removeEventListener('chats:updated', loadChats)
  }, [])

  const loadChats = async () => {
    try {
      setLoading(true)
      const response = await chatsAPI.list()
      setChats(response.data)
      setError(null)
    } catch (err) {
      console.error('Error loading chats:', err)
      setError('Не удалось загрузить чаты')
    } finally {
      setLoading(false)
    }
  }

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  }

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    )
  }

  return (
    <div>
      <div className="d-flex flex-row justify-content-between align-items-start mb-3 mb-md-4 gap-2">
        <h1 className="mb-0 fs-4 fs-md-3">Чаты</h1>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      {chats.length === 0 ? (
        <Alert variant="light" className="border text-center text-muted">
          Чатов пока нет. Создайте чат на странице проекта.
        </Alert>
      ) : (
        <Card className="shadow-sm border-0">
          <div className="list-group list-group-flush">
            {chats.map((chat) => (
              <Link
                key={chat.id}
                to={`/chats/${chat.id}`}
                className="list-group-item list-group-item-action py-3"
              >
                <div className="d-flex justify-content-between align-items-start gap-2">
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="fw-semibold text-truncate">
                      {chat.name}
                      {chat.unread_count > 0 && (
                        <Badge bg="danger" pill className="ms-2 align-middle">
                          {chat.unread_count}
                        </Badge>
                      )}
                    </div>
                    <div className="text-muted small text-truncate">Проект: {chat.project_address}</div>
                    {chat.last_message ? (
                      <div className="text-muted small text-truncate">
                        {chat.last_message.user_email}: {chat.last_message.body}
                      </div>
                    ) : (
                      <div className="text-muted small fst-italic">Сообщений пока нет</div>
                    )}
                  </div>
                  <div className="text-end flex-shrink-0">
                    <Badge bg="light" text="dark" className="border">
                      Участников: {chat.members_count}
                    </Badge>
                    {chat.last_message && (
                      <div className="text-muted small mt-1">{formatTime(chat.last_message.created_at)}</div>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </Card>
      )}
    </div>
  )
}

export default ChatsList
